/**
 * cp-booking-autoreply.js
 * Fires a fire-and-forget beacon to the CathyPaul booking auto-reply worker
 * whenever the appointment form (PDP) or contact form is submitted.
 * Never blocks or alters the real Shopify form submission.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cathypaul-booking.leoleolo.workers.dev/booking';

  function addHoneypot(form) {
    if (!form || form.querySelector('input[name="cp_hp"]')) {
      return;
    }
    form.insertAdjacentHTML(
      'beforeend',
      '<input type="text" name="cp_hp" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-10000px;width:1px;height:1px;opacity:0;">'
    );
  }

  function getValue(formData, key) {
    var value = formData.get(key);
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).replace(/^\s+|\s+$/g, '');
  }

  function buildPayload(form, formType) {
    var formData = new FormData(form);
    var locale = document.documentElement.lang === 'en' ? 'en' : 'zh-TW';

    var payload = {
      name: getValue(formData, 'contact[name]'),
      email: getValue(formData, 'contact[email]'),
      preferred_date: getValue(formData, 'contact[preferred_date]'),
      preferred_time: getValue(formData, 'contact[preferred_time]'),
      website: getValue(formData, 'cp_hp'),
      locale: locale
    };

    if (formType === 'product') {
      var phoneCode = getValue(formData, 'contact[phone_code]');
      var phone = getValue(formData, 'contact[phone]');
      payload.phone = phoneCode ? phoneCode + ' ' + phone : phone;
      payload.notes = getValue(formData, 'contact[notes]');
      payload.product_title = getValue(formData, 'contact[product_title]');
      payload.product_url = getValue(formData, 'contact[product_url]');
    } else {
      payload.phone = getValue(formData, 'contact[phone]');
      payload.notes = getValue(formData, 'contact[body]');
    }

    return payload;
  }

  function sendBooking(payload) {
    var json = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      var blob = new Blob([json], { type: 'text/plain' });
      var queued = navigator.sendBeacon(ENDPOINT, blob);
      if (queued) {
        return;
      }
    }

    if (window.fetch) {
      fetch(ENDPOINT, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: json
      });
    }
  }

  function attach(formId, formType) {
    var form = document.getElementById(formId);
    if (!form) {
      return;
    }

    addHoneypot(form);

    form.addEventListener('submit', function () {
      try {
        var payload = buildPayload(form, formType);
        sendBooking(payload);
      } catch (e) {
        // Never block the real form submission on beacon failure.
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attach('cp-appt-form', 'product');
    attach('cp-contact-form', 'contact');
  });
})();
